export const accountExceptions: any = {
  A000: "El correo y/o la contraseña son incorrectos",
  A001: "Ya existe una cuenta con este correo",
  G000: "No existe un grupo con este nombre",
  U000: "Usuario no encontrado",
  "0000": "Error inesperado",
  "0001": "Error inesperado",
};
